import React, { useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { useMouseTracking } from "../../hooks/useMouseTracking";

const descriptionColStyle = { marginBottom: "2em" };
const headingStyle = { fontSize: "2.6em", textAlign: "center" };

const avatarColStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const avatarImageBaseStyle = {
  maxWidth: "110%",
  width: "110%",
  margin: "0 auto",
  display: "block",
};

function TiltAvatar() {
  const { position, imageRef, containerRef } = useMouseTracking();

  const avatarImageStyle = useMemo(
    () => ({
      ...avatarImageBaseStyle,
      transform: `translate(${position.x * 0.12}px, ${position.y * 0.12}px)`,
    }),
    [position.x, position.y],
  );

  return (
    <Col md={4} ref={containerRef} className="myAvtar" style={avatarColStyle}>
      <Tilt className="avatar-tilt">
        <img
          ref={imageRef}
          src={myImg}
          className="img-fluid"
          alt="avatar"
          style={avatarImageStyle}
        />
      </Tilt>
    </Col>
  );
}

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col
            md={8}
            className="home-about-description"
            style={descriptionColStyle}
          >
            <h1 style={headingStyle}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I've gained extensive experience in building and managing backend
              systems that actually make a difference. From
              <i>
                <b className="purple"> Linux and Grafana to Helm and CI/CD, </b>
              </i>
              I'm all about automating things and making infrastructure clean
              and reliable.
              <br />
              <br />
              I'm proficient in
              <i>
                <b className="purple">
                  {" "}
                  C++, Docker, Kubernetes and Prometheus{" "}
                </b>
              </i>
              — and I enjoy creating
              <i>
                <b className="purple"> Pipelines </b> and managing
                <i>
                  <b className="purple"> Servers. </b>
                </i>
              </i>
              <br />
              <br />
              My key areas of interest include
              <i>
                <b className="purple"> Networking </b>
              </i>
              and exploring new ways to create
              <i>
                <b className="purple">
                  {" "}
                  Reliable and Scalable Infrastructure.{" "}
                </b>
              </i>
              .
              <br />
              <br />
              Whenever possible, I love building projects with
              <b className="purple">
                <i> Node.js </i>
              </b>{" "}
              and modern frameworks like{" "}
              <i>
                <b className="purple">React.js</b> and{" "}
                <b className="purple">Next.js</b>.
              </i>
            </p>
          </Col>
          <TiltAvatar />
        </Row>
      </Container>
    </Container>
  );
}

export default React.memo(Home2);
